<template lang="pug">
div.main-content#home
	//- Header
	div.bg-img.text-center
		div.wrapper
			div.row
				div.col-xs-12
					div.slogan
						h1 Un artisan du web au service des startups
						h2 pour vous aider à atteindre les sommets
					div.cta
						md-button.md-raised.md-primary(href="mailto:contact@nicolasbonnefoy.com?subject=Prise de contact") Prendre rendez-vous
						router-link.md-raised.md-primary(tag="md-button", to='./aboutme') En savoir plus
	div.wrapper
		//- 1st block
		div.row.margin-sep
			div.col-xs-12.text-center
				h2 Donnez à votre entreprise les meilleures chances de réussir en choisissant un CTO hors du commun.
		//- cards
		div.row.center-xs
			div.col-xs-12.div.col-sm-6.col-md-5.col-lg-4
				div.card-container
					md-card
						md-card-media
							img(src="/assets/cofounder.jpg", alt="cofounder")
						md-card-header
							div.md-title Engagez à vos côtés un partenaire qui partage votre vision.
						md-card-content(style="text-align:justify")
							| Avec une vision transverse de la technique et l'expérience du monde des startups, je veille à rationaliser chaque développement pour être le plus efficace tout assurant un code maintenable et évolutif.
							| #[br]Je sais également sortir des sentiers battus pour trouver le prochain hack qui révolutionnera votre produit.
			div.col-xs-12.div.col-sm-6.col-md-5.col-lg-4
				div.card-container
					md-card
						md-card-media
							img(src="/assets/team.jpg", alt="team")
						md-card-header
							div.md-title Offrez à votre équipe un leader expérimenté qui les mènera à l'excellence.
						md-card-content(style="text-align:justify")
							| Parce qu'il n'y a rien de mieux que de travailler avec son équipe en partageant la même culture d'entreprise, je privilégie un poste salarié.
							| #[br]Mon approche du management est orientée vers l'amélioration continue et l'épanouissement de chacun dans l'équipe, tout en sachant prendre les bonnes décisions au bon moment.
				//
					md-tab(id="consultant", md-label="Consultant")
						div.card-container
							md-card(ref="cardConsultant")
								md-card-media
									img(src="/assets/consultant.jpg", alt="team")
								md-card-header
									div.md-title Obtenez des conseils personnalisés, adaptés à vos besoins.
								md-card-content Je vous accompagne au démarrage de votre entreprise, lors d'un changemnt de phase ou à tout moment pour répondre à vos questions techniques.
									ul.card-list
										li Quelle techno, quels outils sont les mieux adaptés à votre activité ?
										li Avez-vous besoin de recruter un CTO ou un developpeur polyvalent ?
										li Pouvez-vous faire confiance aux choix techniques de votre équipe ?
		
		div.row.center-xs.margin-sep-40
			div.col-xs-12.div.col-md-6
				router-link.md-raised.md-accent(tag="md-button", to='./aboutme') En savoir plus
	//- brands
	div.wrapper.brands.margin-sep-40
		div.row.margin-sep
			div.col-xs-12.text-center
				h2 Ils m'ont fait confiance :
		div.row.center-xs.brands-img-container
			div.col-xs-3.col-sm-2
				img(src="/assets/corp/digitas.png", alt="digitas").brands-img
			div.col-xs-3.col-sm-2
				img(src="/assets/corp/tf1.png", alt="tf1").brands-img
			div.col-xs-3.col-sm-2
				img(src="/assets/corp/abbeal.png", alt="abbeal").brands-img
			div.col-xs-3.col-sm-2
				img(src="/assets/corp/ignition.png", alt="ignition program").brands-img
			div.col-xs-3.col-sm-2
				img(src="/assets/corp/prodigious.png", alt="prodigious").brands-img
			div.col-xs-3.col-sm-2
				img(src="/assets/corp/mediastay.png", alt="mediastay").brands-img
	
	//- footer
	div.wrapper
		div.row.simple-footer
			div.col-xs-12.md-caption
				| Nicolas Bonnefoy - 2017 - Winter Edition
</template>

<script>
export default {
	components: {
	
	},
	data(){ return {
		transitionName: 'slide',
		playBanner: false
	}},
	methods: {
		gotoAboutme() {
			this.$router.push({ path: './aboutme' })
		},
		playBannerHandler(){
			this.playBanner = !this.playBanner
			console.log("banner")
		}
	},
	computed: {
	
	},
	created(){
	
	}
}
</script>

<style lang="stylus" scoped>
.card-list
	text-align: left
.brands
	text-align: center
	background-color: #fff
.brands-img
		max-height: 100px
		width: auto
		margin: 0 0 4vh 0
.brands-img-container
	padding: 1% 0
</style>


// WEBPACK FOOTER //
// src/components/Home.vue